<nav class="navbar navbar-expand-sm fixed-top">
  <div [ngClass]="{navlogo: true, 'white-label': whiteLabelMode && platformName == 'LocalVision Ads'}">
    <img [src]="siteLogo" />
  </div>

  <div class="dropdown d-flex">
    <div class="user_budget me-3" *ngIf="showBalance && (role === 'agency_account_manager' ? advertiser_id : clientId)">
      <b>Account Balance :</b
      ><span [ngStyle]="{ color: balanceColor }">
        {{ currency }} {{ amount | number : "1.2-2" }}
      </span>
      <span
        [matTooltip]="balanceTooltipMsg"
        matTooltipClass="tooltip-class"
        class="material-icons tool-tip ms-1"
      >
        error
      </span>
    </div>

    <button
      *ngIf="isObjectEmpty()"
      mat-button
      matBadge="1"
      (click)="openNotification()"
      matBadgeColor="warn"
      class="search-btn notification-btn"
    >
      <mat-icon class="search-btn-icon">notifications</mat-icon>
    </button>

    <button
      mat-button
      [matMenuTriggerFor]="helpMenu"
      class="search-btn nav-user"
    >
      <i
        class="far fa-question-circle search-btn-icon"
        style="font-size: 24px"
      ></i>
    </button>
    <mat-menu #helpMenu="matMenu" yPosition="below">
      <button mat-menu-item>{{ version }}</button>
      <ng-container *ngIf="showDocumentsAndAnalytic">
        <!-- <a
          class="api-spec-link"
          *ngIf="ispfmRole || apnx_enabled"
          href="{{ api_spec_url }}"
          target="_blank"
        >
          <button mat-menu-item>{{platformName}} API Specification - Global (Old)</button>
        </a> -->
        <a
          class="api-spec-link"
          *ngIf="ispfmRole || tdsp_enabled"
          href="{{ tdsp_api_spec_url }}"
          target="_blank"
        >
          <button mat-menu-item>{{platformName}} API Specification - Global</button>
        </a>
        <a
          class="api-spec-link"
          href="{{ vdsp_agn_onboarding_guide_url }}"
          target="_blank"
          *ngIf="
            vdspEnabledPlatformRole('agency') || (isAgnRole && apnx_enabled)
          "
        >
          <button mat-menu-item>Agency Onboarding Guide</button>
        </a>
        <a
        class="api-spec-link"
        href="{{ agn_onboarding_guide_global_url }}"
        target="_blank"
        *ngIf="
          vdspEnabledPlatformRole('agency','tdsp') || (isAgnRole && tdsp_enabled)
        "
      >
        <button mat-menu-item>Agency Onboarding Guide Global</button>
      </a>
      <a
      class="api-spec-link"
      href="{{ adv_onboarding_guide_global_url }}"
      target="_blank"
      *ngIf="
        vdspEnabledPlatformRole('advertiser','tdsp') || (isAgnRole && tdsp_enabled)
      "
    >
      <button mat-menu-item>Advertiser Onboarding Guide Global</button>
    </a>
    <a
     class="api-spec-link"
     href="{{ adsp_policy_guide_url }}"
     target="_blank"
     *ngIf="
       adspEnabledPlatformRole('advertiser') ||
       adspEnabledPlatformRole('agency') ||
       adspEnabled
     "
   >
     <button mat-menu-item>{{platformName}} Amazon DSP Policies</button>
   </a>
         <!-- <a
          class="api-spec-link"
          href="{{ vdsp_agn_helper_guide_url }}"
          target="_blank"
          *ngIf="
            vdspEnabledPlatformRole('agency') || (isAgnRole && apnx_enabled)
          "
        >
          <button mat-menu-item>
            {{platformName}} DSP User Manual
            <span *ngIf="ispfmRole">(Agency)</span>
          </button>
        </a>
         <a
          class="api-spec-link"
          href="{{ vdsp_adv_helper_guide_url }}"
          target="_blank"
          *ngIf="
            vdspEnabledPlatformRole('advertiser') ||
            (isNonAPIAdvRole && apnx_enabled)
          "
        >
          <button mat-menu-item>
            {{platformName}} DSP User Manual
            <span *ngIf="ispfmRole">(Advertiser)</span>
          </button>
        </a>
         -->
        <a
        class="api-spec-link"
        href="{{ global_adv_helper_guide_url }}"
        target="_blank"
        *ngIf="
          vdspEnabledPlatformRole('advertiser','tdsp') ||
          (isNonAPIAdvRole && tdsp_enabled)
        "
      >
        <button mat-menu-item>
          {{platformName}} DSP User Manual
          <span *ngIf="ispfmRole">(Advertiser)</span>
        </button>
      </a>
      <a
      class="api-spec-link"
      href="{{ global_agn_helper_guide_url }}"
      target="_blank"
      *ngIf="
        vdspEnabledPlatformRole('agency','tdsp') ||
        (isAgnRole && tdsp_enabled)
      "
    >
      <button mat-menu-item>
        {{platformName}} DSP User Manual
        <span *ngIf="ispfmRole">(Agency)</span>
      </button>
    </a>

        <a
          class="api-spec-link"
          href="{{ vdsp_creative_macros_guide_url }}"
          target="_blank"
          *ngIf="
            vdspEnabledPlatformRole('advertiser') ||
            (isNonAPIAdvRole && apnx_enabled)
          "
        >
          <button mat-menu-item>{{platformName}} DSP Creative Macros User Manual</button>
        </a>
        <!-- ToDO:
        1.Uncomment this, once Advertiser onboarding guidelines is available.
        2.Update the url for the doc in common.ts
        <a class="api-spec-link" href={{adv_onboarding_guide_url}}
        target="_blank" *ngIf="!allAgcRoles.includes(role)"
        >
        <button mat-menu-item>Advertiser Onboarding Guide</button>
      </a> -->
      </ng-container>
    </mat-menu>

    <span class="user_name">Hi, {{ getUsername() }}</span>
    <button mat-button [matMenuTriggerFor]="profileMenu">
      <i
        class="fas fa-user-circle user-circle mb-1"
        style="font-size: 24px"
      ></i>
      <span class="user-detail down-arrow me-5"
        ><i class="fas fa-chevron-down"></i
      ></span>
    </button>
    <mat-menu #profileMenu="matMenu" yPosition="above">
      <button mat-menu-item class="profile-menu">
        <div class="profile-img">
          <i class="far fa-user-circle"></i>
        </div>
        <!-- <div class="user-detail">
      <div class="font-weight-bold"> {{ role }}</div> -->
        <!-- <div class="">{{user?.company_name || 'User'}}</div> -->
        <!-- </div> -->
      </button>
      <button
        mat-menu-item
        *ngIf="validateAccounts()"
        class="dropdown-item"
        routerLink="/profile/myaccount"
        [queryParams]="{
          agency_advertiser_id: agency_advertiser_id,
          advertiser_id: advertiser_id,
          agency_id: agency_id
        }"
      >
        <i class="fas fa-cog"></i>Manage Funds
      </button>
      <button
        mat-menu-item
        class="dropdown-item"
        routerLink="/profile/userdetails/"
        [queryParams]="{
          agency_advertiser_id: agency_advertiser_id,
          advertiser_id: advertiser_id,
          agency_id: agency_id
        }"
      >
        <i class="fas fa-cog"></i>My Profile
      </button>
      <button
        *ngIf="
          analyticsEnabled &&
          showDocumentsAndAnalytic &&
          (role == 'agency_primary_admin' || role == 'advertiser_primary_admin')
        "
        mat-menu-item
        class="dropdown-item"
        routerLink="/profile/analytics-license-management"
        [queryParams]="{
          agency_advertiser_id: agency_advertiser_id,
          advertiser_id: advertiser_id,
          agency_id: agency_id
        }"
      >
        <i class="fa fa-id-card" aria-hidden="true"></i>
        Analytics License Management
      </button>
      <button
        mat-menu-item
        class="dropdown-item"
        routerLink="/profile/updatepassword"
        [queryParams]="{
          agency_advertiser_id: agency_advertiser_id,
          advertiser_id: advertiser_id,
          agency_id: agency_id
        }"
      >
        <i class="fas fa-cog"></i>Update Password
      </button>
      <button mat-menu-item class="dropdown-item" (click)="logout()">
        <i class="fas fa-power-off"></i>Logout
      </button>
    </mat-menu>
  </div>
</nav>
